// extracted by mini-css-extract-plugin
export default {"home_pride_parent":"Prides_home_pride_parent__TbeK8","container":"Prides_container__aSznX","pride_inner":"Prides_pride_inner__LhyPa"};